import React from 'react';
import { safeHTML } from '../../../../utils/safeHTML';

const Score = React.forwardRef(function Score({ score }, ref) {
  return (
    <div className={'score'}>
      <div className={'score__title'}>{safeHTML(`+${score}XP`)}</div>
    </div>
  );
});

export default Score;
